import React from "react";
import useLogin from "../Pages/Login/useLogin";
import AuthInput from "./AuthInput";
import OTPInput from "./OTPInput";
import useCreateUser from "../Pages/Admin/AdminDashboard/useCreateUser";

export default function CreateUserModal({ open, onClose }) {
  const {
  
    signupHandleSubmit,
    signupRegister,
    onSignup,
    signupErrors,
    plans,
    loadingPlans,
    selectedPlan,
    setSelectedPlan,
 
  } = useCreateUser({ isModal: true, onClose });

  if (!open) return null;

  return (
    <div
      // onClick={onClose}
      className="modal bg-black/80 h-screen fixed left-0 flex justify-center items-center top-0 w-full z-40 px-6 py-3 md:px-10"
    >
      <div
        className="bg-blueGray max-h-[95vh] p-6 px-4 md:px-8 rounded-md max-w-xl w-full my-auto md:mx-auto border border-borderGray overflow-y-scroll"
        onClick={e => e.stopPropagation()}
      >
      

     
           

            {/* Create User Form */}
              <form onSubmit={signupHandleSubmit(onSignup)} className="bg-transparent p-0 rounded text-white">
                <h1 className="mb-6 text-2xl text-center font-bold text-white">Create New User</h1>
                <AuthInput label="Name" errors={signupErrors} register={signupRegister} type="text" name="name" id="name" placeholder="Enter user name" />
                <AuthInput label="Email" errors={signupErrors} register={signupRegister} type="email" name="email" id="email" placeholder="Email" />
                
                {/* Plan Selection */}
                <div className="flex flex-col mb-4">
                  <label htmlFor="plan" className="mb-2 text-sm text-gray-400">Select Plan</label>
                  <select
                    {...signupRegister("planId", { required: "Plan is required" })}
                    id="plan"
                    className="p-3 rounded-md bg-transparent border border-borderGray text-white focus:outline-none focus:border-secondary"
                    onChange={(e) => setSelectedPlan(e.target.value)}
                    value={selectedPlan}
                  >
                    <option value="" className="bg-blueGray">Select a Plan</option>
                    {loadingPlans ? (
                      <option disabled className="bg-blueGray">Loading plans...</option>
                    ) : (
                      plans
                        .filter(plan => !(plan?.name === "Free"))
                        .map(plan => (
                          <option key={plan._id} value={plan._id} className="bg-blueGray">
                            {plan.name === "Custom"
                              ? plan.name
                              : `${plan.name} - $${plan.price}/${plan.interval === "none" ? "lifetime" : plan.interval}`}
                          </option>
                        ))
                    )}
                  </select>
                  
                </div>

                <AuthInput label="Password" errors={signupErrors} register={signupRegister} type="password" name="password" id="password" placeholder="Password" />
                <AuthInput label="Confirm Password" errors={signupErrors} register={signupRegister} type="password" name="password_confirmation" id="cpassword" placeholder="Confirm Password" />
                <button
                  type="submit"
                  className="uppercase w-full mt-4 p-3 rounded-md bg-secondary hover:bg-secondary/75 text-white"
                >
                  Create User
                </button>
              </form>
       

        <button onClick={onClose} className="mt-4 text-gray-400 hover:text-white w-full transition">Close</button>
      </div>
    </div>
  );
} 
